import PasswordGate from './PasswordGate';
import ContentRewardsPitchDeck from './ContentRewardsPitchDeck';

const CONTENT_REWARDS_LOGO = 'https://jlqgwkkdzpadbmnyqnnk.supabase.co/storage/v1/object/public/public_bucket/vdr_contentrewards/contentrewards_logo.avif';

export default function ContentRewardsDeckViewer() {
  return (
    <PasswordGate
      deckSlug="content-rewards"
      deckName="Content Rewards Pitch Deck"
      logoUrl={CONTENT_REWARDS_LOGO}
    >
      <ContentRewardsPitchDeck />
    </PasswordGate>
  );
}
